import { render } from "./ArticleSpeechForShowPage.vue?vue&type=template&id=1ac4374e&scoped=true&ts=true&lang=pug"
import script from "./ArticleSpeechForShowPage.vue?vue&type=script&lang=ts"
export * from "./ArticleSpeechForShowPage.vue?vue&type=script&lang=ts"

import "./ArticleSpeechForShowPage.vue?vue&type=style&index=0&id=1ac4374e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac4374e"]])

export default __exports__